export default __webpack_public_path__ + "static/media/upload_file.bf5d0a23.svg";